module.exports = __webpack_public_path__ + "img/eyein-partner-bell.6cf79ab3.png";